import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./auth/authSlice";
import sessionUserSlice from "./sessionUser/sessionUserSlice";

const rootReducer = combineReducers({
  auth: authSlice,
  sessionUser: sessionUserSlice,
});

export default rootReducer;
